import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  & p {
    text-transform: capitalize;
  }

  & .tableWrapper {
    overflow: auto;
    max-height: 380px;
    display: block;
    margin-inline: -30px;
    width: calc(100% + 60px);

    .core-table-thead tr {
      height: auto !important;
    }

    th {
      height: auto !important;
      padding: 16px;
      text-align: left !important;
    }

    th:first-child,
    td:first-child {
      padding-left: 30px;
    }

    td:last-child {
      padding-right: 30px;
    }

    td {
      padding: 12px 16px;
    }

    tr {
      position: relative;
      border: none;
    }

    .centerText {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .defaultMethod {
      background: var(--color-surface-muted);
    }
  }
`;
